<template>
    <div>
        <transition name="fade">
            <div
                class="progress-notification-container"
                v-if="progress.totalSteps > 0"
            >
                <radial-progress-bar
                    :diameter="diameter"
                    :completed-steps="progress.completedSteps"
                    :total-steps="progress.totalSteps"
                    :animateSpeed="progress.animateSpeed"
                    :inner-stroke-color="progress.innerStrokeColor"
                    :inner-stroke-width="progress.innerStrokeWidth"
                    :stroke-width="progress.strokeWidth"
                    :start-color="progress.startColor"
                    :stop-color="progress.stopColor"
                >
                    <h3 class="p-1 m-0" style="color: #626262">
                        <animated_number
                            :number="
                ((progress.completedSteps / progress.totalSteps) * 100).toFixed(
                  0
                )
              "
                        >
                        </animated_number>
                        %
                    </h3>
                    <h4 class="p-1 m-0 pulsate" style="color: #626262">
                        {{ progress.title }}
                    </h4>
                </radial-progress-bar>
            </div>
        </transition>
        <form name="register">
            <div
                v-if="hideEmail && formData.email"
                class="p-x-10 p-b-5 text-center"
            >
                <small>
                    {{ lang.email }}
                    <a @click="hideEmail = !hideEmail">
                        {{ formData.email }}
                    </a>
                </small>
            </div>
            <div
                v-if="
                !hideEmail || !formData.email || errors.hasOwnProperty('email')
              "
                class="form-group form-group-default"
                :class="{ 'has-error': errors.hasOwnProperty('email') }"
            >
                <label for="email">{{ lang.email }}</label>
                <input
                    type="email"
                    class="form-control"
                    id="email"
                    :placeholder="lang.email_placeholder"
                    v-model="formData.email"
                    autocomplete="off"
                    required
                />
                <div class="text-danger" v-if="errors.hasOwnProperty('email')">
                    {{ errors["email"] }}
                </div>
            </div>
            <div
                class="form-group form-group-default"
                :class="{ 'has-error': errors.hasOwnProperty('password') }"
            >
                <label for="password">{{ lang.password }}</label>
                <input
                    type="password"
                    name="password"
                    class="form-control"
                    id="password"
                    v-model="formData.password"
                    autocomplete="off"
                    required
                />
                <div class="text-danger" v-if="errors.hasOwnProperty('password')">
                    {{ errors["password"] }}
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div
                        class="form-group form-group-default"
                        :class="{ 'has-error': errors.hasOwnProperty('fname') }"
                    >
                        <label for="fname">{{ lang.fname }}</label>
                        <input
                            type="text"
                            class="form-control"
                            id="fname"
                            name="fname"
                            v-model="formData.fname"
                            autocomplete="off"
                            required
                        />
                        <div
                            class="text-danger"
                            v-if="errors.hasOwnProperty('fname')"
                        >
                            {{ errors["fname"] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div
                        class="form-group form-group-default"
                        :class="{ 'has-error': errors.hasOwnProperty('sname') }"
                    >
                        <label for="sname">{{ lang.sname }}</label>
                        <input
                            type="text"
                            class="form-control"
                            id="sname"
                            name="sname"
                            v-model="formData.sname"
                            autocomplete="off"
                            required
                        />
                        <div
                            class="text-danger"
                            v-if="errors.hasOwnProperty('sname')"
                        >
                            {{ errors["sname"] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div
                        class="form-group form-group-default"
                        :class="{ 'has-error': errors.hasOwnProperty('company') }"
                    >
                        <label for="company">{{ lang.company }}</label>
                        <input
                            type="text"
                            class="form-control"
                            id="company"
                            name="company"
                            v-model="formData.company"
                            autocomplete="off"
                            required
                        />
                        <div
                            class="text-danger"
                            v-if="errors.hasOwnProperty('company')"
                        >
                            {{ errors["company"] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div
                        class="form-group form-group-default"
                        :class="{ 'has-error': errors.hasOwnProperty('phone') }"
                    >
                        <label for="phone">{{ lang.phone }}</label>
                        <input
                            type="tel"
                            class="form-control"
                            id="phone"
                            name="phone"
                            v-model="formData.phone"
                            autocomplete="off"
                            required
                        />
                        <div
                            class="text-danger"
                            v-if="errors.hasOwnProperty('phone')"
                        >
                            {{ errors["phone"] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6"></div>
                <div class="col-md-6"></div>
            </div>
            <div
                v-if="
                !hideIndustrySelector ||
                !formData.industry ||
                errors.hasOwnProperty('industry')
              "
                class="form-group form-group-default"
                :class="{ 'has-error': errors.hasOwnProperty('industry') }"
                style="background-color: #fff"
            >
                <label class="pl-2">
                    {{ lang.industry }}
                    <Select2
                        id="industry"
                        v-model="formData.industry"
                        :options="industries"
                        :settings="{
                    containerCssClass: 'select2-custom-container',
                    placeholder: lang.industry_placeholder,
                  }"
                    />
                </label>
                <div class="text-danger" v-if="errors.hasOwnProperty('industry')">
                    {{ errors["industry"] }}
                </div>
            </div>
            <div
                v-if="
                !hideCountrySelector ||
                !formData.country ||
                errors.hasOwnProperty('country')
              "
                class="form-group form-group-default"
                style="background-color: #fff"
                :class="{ 'has-error': errors.hasOwnProperty('country') }"
            >
                <label id class="pl-2">
                    {{ lang.country }}
                    <Select2
                        id="countries"
                        v-model="formData.country"
                        :options="countries"
                        :settings="{
                    containerCssClass: 'select2-custom-container',
                    placeholder: lang.country_placeholder,
                  }"
                        @select="onCountrySelect"
                    />
                </label>
                <div class="text-danger" v-if="errors.hasOwnProperty('country')">
                    {{ errors["country"] }}
                </div>
            </div>
            <div
                class="form-group form-group-default"
                style="background-color: #fff"
                v-if="
                !hideTimezoneSelector ||
                !formData.timezone ||
                errors.hasOwnProperty('timezone')
              "
                :class="{ 'has-error': errors.hasOwnProperty('timezone') }"
            >
                <label class="pl-2">
                    {{ lang.timezone }}
                    <Select2
                        v-model="formData.timezone"
                        :options="timezones"
                        :settings="{ containerCssClass: 'select2-custom-container' }"
                    />
                </label>
                <div class="text-danger" v-if="errors.hasOwnProperty('timezone')">
                    {{ errors["timezone"] }}
                </div>
            </div>
            <div
                class="form-group form-group-default"
                style="background-color: #fff"
                v-if="
                !hideCurrencySelector ||
                !formData.currency ||
                errors.hasOwnProperty('currency')
              "
                :class="{ 'has-error': errors.hasOwnProperty('currency') }"
            >
                <label class="pl-2">
                    {{ lang.currency }}
                    <Select2
                        id="currencies"
                        v-model="formData.currency"
                        :options="currencies"
                        :settings="{
                    containerCssClass: 'select2-custom-container',
                  }"
                    />
                </label>
                <div class="text-danger" v-if="errors.hasOwnProperty('currency')">
                    {{ errors["currency"] }}
                </div>
            </div>
            <div
                class="form-group form-group-default"
                :class="{ 'has-error': errors.hasOwnProperty('promo') }"
                v-if="
                hidePromoCodeSelector ||
                formData.promo ||
                errors.hasOwnProperty('promo')
              "
            >
                <label for="promo">{{ lang.promo }}</label>
                <input
                    type="text"
                    class="form-control"
                    id="promo"
                    name="promo"
                    v-model="formData.promo"
                    autocomplete="off"
                />
                <div
                    class="text-danger"
                    v-if="errors.hasOwnProperty('promo')"
                >
                    {{ errors["promo"] }}
                </div>
            </div>
            <recaptcha
                v-model="formData.recaptcha"
                ref="captcha"
                id="signup_id"
                :siteKey="recaptcha_site_key"
                inline
                action="signup"
            ></recaptcha>
            <div class="text-danger" v-if="errors.hasOwnProperty('recaptcha')">
                {{ errors["recaptcha"] }}
            </div>
            <div class="p-x-10 p-b-5 text-center"
                 v-if="!hidePromoCodeSelector && !formData.promo && !errors.hasOwnProperty('promo')">
                <small>
                    <a @click="hidePromoCodeSelector = !hidePromoCodeSelector">
                        Got a promo code?
                    </a>
                </small>
            </div>
            <button
                type="button"
                class="btn-xl text-xl btn btn-success w-100  btn-cons text-uppercase"
                :disabled="loading"
                @click="onSubmit"
            >
                <span>{{ lang.p2_button }}</span>
            </button>
            <div class="p-x-10 p-b-5 text-center"
                 v-if="hideIndustrySelector || hideCountrySelector || hideTimezoneSelector || hideCurrencySelector">
                <small>
                <span
                    v-if="
                    hideIndustrySelector &&
                    formData.industry &&
                    !errors.hasOwnProperty('industry')
                  "
                >
                  {{ lang.industry }}
                  <strong>
                    {{ selectedIndustryByName }}
                  </strong>
                  -
                </span>
                    <span
                        v-if="
                    hideCountrySelector &&
                    formData.country &&
                    !errors.hasOwnProperty('country')
                  "
                    >
                  {{ lang.country }}
                  <strong>
                    {{ formData.country }}
                  </strong>
                  -
                </span>
                    <span
                        v-if="
                    hideTimezoneSelector &&
                    formData.timezone &&
                    !errors.hasOwnProperty('timezone')
                  "
                    >
                  {{ lang.timezone }}
                  <strong>
                    {{ formData.timezone }}
                  </strong>
                  -
                </span>
                    <span
                        v-if="
                    hideCurrencySelector &&
                    formData.currency &&
                    !errors.hasOwnProperty('currency')
                  "
                    >
                  {{ lang.currency }}
                  <strong>
                    {{ formData.currency }}
                  </strong>
                </span><a @click="
                    hideCurrencySelector = false;
                    hideIndustrySelector = false;
                    hideCountrySelector = false;
                    hideTimezoneSelector = false;"> change?</a>
                </small>
            </div>
            <div class="text-center p-t-10">
                <small v-html="lang.agree_terms"></small><br/><br/>

                <small v-if="login_link"
                >{{ lang.have_an_account }}
                    <a :href="login_url" class="text-primary">{{
                            lang.login
                        }}</a></small
                >
            </div>
        </form>
    </div>
</template>

<script>
import axios from "axios";
import recaptcha from "../googlerecaptchav3/GoogleReCaptchaV3";
import RadialProgressBar from "vue-radial-progress";
import animated_number from "../AnimatedNumber";

export default {
    name: "Registration",
    props: {
        endpoint: {
            type: String,
        },
        login_url: {
            type: String,
        },
        index_url: {
            type: String,
        },
        lang: {
            type: Object,
        },
        pre_form_data: {
            type: Object,
        },
        show_fields: {
            type: Array,
        },
        locale: {
            type: String,
            default: "en",
        },
        timezones: {
            type: Array,
        },
        countries: {
            type: Array,
        },
        currencies: {
            type: Array,
        },
        industries: {
            type: Array,
        },
        conversion_tracking: {
            type: Object,
        },
        recaptcha_site_key: {
            type: String,
        },
        login_link: {
            type: Boolean
        }
    },
    data() {
        return {
            echo: null,
            loading: false,
            info: {
                currencies: [],
                location: "",
            },
            formData: {
                email: "",
                currency: "",
                industry: "",
                timezone: "",
                promo: "",
                company: "",
                fname: "",
                sname: "",
                first_page_url: "",
            },
            gRecaptchaResponse: null,
            hideEmail: false,
            hideIndustrySelector: false,
            hideCountrySelector: false,
            hideTimezoneSelector: false,
            hideCurrencySelector: false,
            hidePromoCodeSelector: false,
            errors: {},
            success: false,
            loadingText: "",
            progress: {
                // channelPrefix: window.company.channelPrefix,
                display: false,
                title: "Loading",
                description: "",
                percentage: 33,
                completedSteps: 3,
                totalSteps: 0,
                animateSpeed: 800,
                startColor: "#6d5cae",
                stopColor: "#6d5cae",
                innerStrokeColor: "#eaeaea",
                fps: 30,
                stokeLineCap: "round",
                strokeWidth: 4,
                innerStrokeWidth: 3,
                maxDiameter: 400,
            },
        };
    },
    created() {
        this.loading = true;
        let url = new URL(location.href);

        //Overwrite and show fields if data passed
        if (this.show_fields.length > 0) {
            for (const element of this.show_fields) {
                if (this.hasOwnProperty(element)) {
                    this[element] = true;
                }
            }
        }

        //Try prepopulate email
        if (url.searchParams.has("email")) {
            this.formData.email = url.searchParams.get("email");
            this.hideEmail = true;
        }

        //Try prepopulate company
        if (url.searchParams.has("company_name")) {
            this.formData.company = url.searchParams.get("company_name");
        }

        //Try prepopulate firstname
        if (url.searchParams.has('first_name')) {
            this.formData.fname = url.searchParams.get('first_name');
        }

        //Try prepopulate lastname
        if (url.searchParams.has('last_name')) {
            this.formData.sname = url.searchParams.get('last_name');
        }

        //Try prepopulate industry
        if (this.pre_form_data.industry) {
            let industry = this.industries.find(
                (i) => i.alias === this.pre_form_data.industry
            );
            if (industry) {
                this.formData.industry = industry.id.toString();
                this.hideIndustrySelector = true;
            }
        } else if (url.searchParams.has("i")) {
            let industry = this.industries.find(
                (i) => i.alias === url.searchParams.get("i")
            );
            if (industry) {
                this.formData.industry = industry.id.toString();
                this.hideIndustrySelector = true;
            }
        }

        //Try prepopulate promocode
        if (url.searchParams.has("p")) {
            this.formData.promo = url.searchParams.get("p");
            this.hidePromoCodeSelector = true;
        } else {
            this.formData.promo = this.$cookies.get("promo");
        }

        //Force referral
        if (this.pre_form_data.hasOwnProperty('referred_by')) {
            this.formData.referred_by = this.pre_form_data.referred_by;
        } else {
            //Check referral
            this.formData.referred_by = this.$cookies.get("referral");
        }

        if (window.cookieManager.getFirstPageCookie()) {
            this.formData.first_page_url = window.cookieManager.getFirstPageCookie();
        }

        //Fetch registration information from API
        axios
            .create({baseURL: this.endpoint, headers: {Locale: this.locale}})
            .get("/auth/register/data")
            .then((response) => (this.info = response.data))
            .catch((error) => {
                if (error.response.data.hasOwnProperty("message")) {
                    this.$root.alert("danger", error.response.data.message);
                }
            })
            .then(() => {
                this.loading = false;
                //Try prepopulate country from locale(cloudflare)
                if (
                    this.info.location &&
                    this.countries.some(
                        (c) => c.code === this.info.location.toUpperCase()
                    )
                ) {
                    this.formData.country = this.info.location.toUpperCase();
                    this.formData.currency = this.countries.find(
                        (country) => country.code === this.formData.country
                    ).currency;
                    this.hideCountrySelector = true;
                    this.hideCurrencySelector = true;
                }
            });
        //Guess timezone
        this.bestGuessTz();
    },
    computed: {
        selectedIndustryByName: function () {
            if (!!this.formData.industry) {
                if (this.industries.hasOwnProperty(this.formData.industry)) {
                    return this.industries[this.formData.industry].text;
                }
            }
            return "N/A";
        },
        diameter: function () {
            let proposedDiameter = Number((window.innerWidth * 0.8).toFixed(0));
            if (proposedDiameter > this.progress.maxDiameter) {
                return Number(this.progress.maxDiameter);
            } else {
                return Number(proposedDiameter);
            }
        },
    },
    methods: {
        onCountrySelect(country) {
            let value = country.code;
            this.formData.currency = this.countries.find(
                (country) => country.code === value
            ).currency;
        },
        onSubmit(e) {
            e.preventDefault();

            let vm = this;
            this.errors = {};
            this.loading = true;

            axios
                .create({
                    baseURL: this.endpoint,
                    headers: {Locale: this.locale},
                })
                .post("/auth/register/step2", this.formData)
                .then((response) => {
                    this.success = true;
                    this.progress.display = true;
                    this.listenToProgress(response.data.channel);
                })
                .catch((error) => {
                    if (error.response && error.response.data.hasOwnProperty("errors")) {
                        let responseErrors = error.response.data.errors;

                        let errors = {};
                        for (let key in responseErrors) {
                            errors[key] = responseErrors[key][0];
                        }

                        vm.errors = errors;
                    }
                    if (error.response && error.response.data.hasOwnProperty("message")) {
                        this.$root.alert("danger", error.response.data.message);
                    }

                    this.progress.display = false;
                    this.loading = false;
                });

            this.$refs.captcha.execute();
        },
        bestGuessTz() {
            let guess = this.$moment.tz.guess();
            if (this.timezones.includes(guess)) {
                this.formData.timezone = guess;
                this.hideTimezoneSelector = true;
                return true;
            }

            let guessByCountry = this.guessByCountry(this.locale);
            if (guessByCountry.length > 0) {
                this.formData.timezone = guessByCountry[0];
                this.hideTimezoneSelector = true;
                return true;
            } else {
                this.formData.timezone = "";
                return true;
            }
        },
        guessByCountry(countryCode) {
            return this.$moment.tz
                .zonesForCountry(countryCode)
                .filter((obj) => this.timezones.includes(obj));
        },
        listenToProgress(channel) {
            let vm = this;
            this.echo = window.EchoService.init();
            this.echo.channel(channel)
                .listen('RegistrationProgressAdvance', (e) => {
                    vm.progress.totalSteps = e.total;
                    vm.progress.completedSteps = e.processed;
                    vm.progress.title = e.title;

                    if (e.data.hasOwnProperty("redirect_url")) {
                        // Google
                        gtag(
                            this.conversion_tracking.google.type,
                            this.conversion_tracking.google.name,
                            this.conversion_tracking.google.data
                        );
                        // Facebook
                        fbq(
                            this.conversion_tracking.facebook.type,
                            this.conversion_tracking.facebook.name,
                            this.conversion_tracking.facebook.data
                        );
                        // Capterra
                        capTrack();
                        // Google Analytics Event
                        gtag(this.conversion_tracking.ga.type, this.conversion_tracking.ga.name, this.conversion_tracking.ga.data)
                        // Bing
                        window.uetq = window.uetq || [];
                        window.uetq.push('event', this.conversion_tracking.bing.event, this.conversion_tracking.bing.data);
                        setTimeout(function () {
                            location.href = e.data.redirect_url;
                        }, 1000);
                    }

                    if (e.hasOwnProperty("messages") && e.messages.length > 0) {
                        e.messages.forEach(function (message) {
                            for (let style in message) {
                                vm.$root.alert(style, message[style]);

                                if (style == "danger") {
                                    vm.loading = false;
                                }
                            }
                        });
                    }
                });
        },
    },
    components: {
        recaptcha,
        animated_number,
        RadialProgressBar,
    },
};
</script>

<style scoped>
#signup_id {
    visibility: collapse !important;
    height: 0;
}

.slide-fade-enter-active {
    transition: all 0.5s ease;
}

.slide-fade-leave-active {
    transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.pulsate {
    -webkit-animation: pulsate 3s ease-out;
    -webkit-animation-iteration-count: infinite;
    opacity: 0.6;
}

@-webkit-keyframes pulsate {
    0% {
        opacity: 0.6;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0.6;
    }
}
</style>
